import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-archivo',
  templateUrl: './archivo.component.html',
  styleUrls: ['./archivo.component.css']
})
export class ArchivoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
